module.exports = __webpack_public_path__ + "static/media/login-cover.8d54cea4.jpg";